module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAASCAYAAACNdSR1AAAAw0lEQVQokY3SMUpDQRSF4e+FFBYK4ha0EndgbW1stHELgtjrFlyErWihYJVaSZkUgoU7sBE7wWMRAs/Hm+f8cJvhn8OZyzRJGkQFI1xjt1bewQsOa2TYwD2u0BTtJI/5y12S9SS6M+q5f4RnbJdqdNnDDAc1MmzhCRdDnfu4SbI2Hkhuc4pFTfJ3kvMk/kv+wAmmGJTnlmt8Xx2UtnGL/bbYJ//gEsf46ia0a3xavvqh1Gslv2GC15IIkpwl2ez7ON35BRN1s5NnRzi5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/galerie.png
// module id = mso4
// module chunks = 0